import React from "react";
import {WebApp} from "../../../constants";
import {InlineLink, Paragraph, Regular, Title, useTermsText} from "../TermsText";

const PrivacyForceSection = () => {
  const {navigation} = useTermsText();

  return (
    <>
      <Title>{"10. Privacy."}</Title>

      <Paragraph>
        {"We respect your privacy and are committed to protecting it. Our "}<Regular>{"Privacy Policy"}</Regular>{", "}<InlineLink
        onPress={() => navigation.navigate('PrivacyPolicy')}>{WebApp}{"/privacy"}</InlineLink>{", governs the processing of all personal data collected from you in connection with your purchase of products or services through the Site."}
      </Paragraph>

      <Title>{"11. Force Majeure."}</Title>

      <Paragraph>
        {"We will not be liable or responsible to you, nor be deemed to have defaulted or breached these Terms, for any failure or delay in our performance under these Terms when and to the extent such failure or delay is caused by or results from acts or circumstances beyond our reasonable control, including, without limitation, acts of God, flood, fire, earthquake, explosion, governmental actions, war, invasion or hostilities (whether war is declared or not), terrorist threats or acts, riot or other civil unrest, national emergency, revolution, insurrection, epidemic, lockouts, strikes or other labor disputes (whether or not relating to our workforce), or restraints or delays affecting carriers or inability or delay in obtaining supplies of adequate or suitable materials, materials or telecommunication breakdown or power outage."}
      </Paragraph>
    </>
  );
};

export default React.memo(PrivacyForceSection);
